/**
 * Static-asset path helper.
 *
 * Create React App serves everything under `/public` from `PUBLIC_URL` (which is
 * "" in dev and the deploy sub-path in production). Building asset URLs by hand
 * (`${process.env.PUBLIC_URL}/...`) was repeated in several files — this
 * centralises it so there is one correct way to reference a public file.
 */
export const PUBLIC = process.env.PUBLIC_URL || '';

/**
 * Resolve a file that lives under `/public`.
 * @param {string} relPath path relative to /public, e.g. 'prototype/map.svg'
 * @returns {string} an absolute URL that works in dev and production
 */
export const asset = (relPath) => `${PUBLIC}/${String(relPath).replace(/^\/+/, '')}`;
